import { FC, useContext } from 'react';

import { Paragraph, H3 } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import s from './EditPhoto.module.scss';

export const EditPhotoTooltip: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s.tooltip}>
      <H3 className={s.tooltip_title}>{t('setting.shell.bg.sizes')}</H3>
      <ul className={s.tooltip_list}>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>
            {t('application.image.minRes')}
          </span>
          <span className={s.tooltip_size}>248x248</span>
        </li>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>
            {t('goods.edit.photo.optimalRes')}
          </span>
          <span className={s.tooltip_size}>{'600x600'}</span>
        </li>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>{t('application.image.sides')}</span>
          <span className={s.tooltip_size}>{'1:1'}</span>
        </li>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>
            {t('application.image.maxSize')}
          </span>
          <span className={s.tooltip_size}>{'250 kb'}</span>
        </li>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>
            {t('application.image.format')}
          </span>
          <span className={s.tooltip_size}>{'.jpg, .png'}</span>
        </li>
      </ul>
      <Paragraph size={'s'} color="secondary" className={s.tooltip__text}>
        {t('application.game.image.size.help')}
      </Paragraph>
    </div>
  );
};
